import script from "./SearchResultDetailsTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultDetailsTitle.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultDetailsTitle.vue?vue&type=style&index=0&id=36428ecc&lang=scss"

const __exports__ = script;

export default __exports__